import { useCallback } from 'react';
import { useFormContext } from 'react-hook-form';

export const useFormValueSetter = () => {
    const { setValue } = useFormContext();

    const setFormValue = useCallback(
        (name, value) => {
            setValue(name, value, {
                shouldDirty: true,
                shouldTouch: true,
                shouldValidate: true,
            });
        },
        [setValue],
    );

    return setFormValue;
};
